import { render, staticRenderFns } from "./TgbSplitButton.vue?vue&type=template&id=38cd3686&scoped=true"
import script from "./TgbSplitButton.vue?vue&type=script&lang=js"
export * from "./TgbSplitButton.vue?vue&type=script&lang=js"
import style0 from "./TgbSplitButton.vue?vue&type=style&index=0&id=38cd3686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd3686",
  null
  
)

export default component.exports